/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const ConnectionIcon = ({
  className,
  style,
  color = '#ADA9BB',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2.99996V2.74996C0 2.54371 0.16875 2.37496 0.375 2.37496H3.68125C3.78438 2.37496 3.88438 2.41871 3.95625 2.49684L6.75938 5.52809L6.07813 6.26559L3.40625 3.37496H0.375C0.16875 3.37496 0 3.20621 0 2.99996ZM15.7063 11.7062L13.7063 13.7062C13.0781 14.3343 12 13.8875 12 13V11.625H11.1969C11.0938 11.625 10.9938 11.5812 10.9219 11.5031L8.11875 8.47184L8.8 7.73434L11.4688 10.625H12V8.99996C12 8.10934 13.0781 7.66559 13.7063 8.29371L15.7063 10.2937C16.0969 10.6843 16.0969 11.3156 15.7063 11.7062ZM15.0875 10.9125L13.0875 8.91246C13.0094 8.83434 12.875 8.89059 12.875 8.99996V13C12.875 13.1125 13.0094 13.1687 13.0875 13.0875L15.0875 11.0875C15.1375 11.0406 15.1375 10.9593 15.0875 10.9125ZM15.7063 3.70621L13.7063 5.70621C13.0781 6.33434 12 5.88746 12 4.99996V3.37496H11.4688L3.95625 11.5031C3.88438 11.5812 3.78438 11.625 3.68125 11.625H0.375C0.16875 11.625 0 11.4562 0 11.25V11C0 10.7937 0.16875 10.625 0.375 10.625H3.40625L10.9188 2.49684C10.9906 2.41871 11.0906 2.37496 11.1938 2.37496H12V0.999963C12 0.109339 13.0781 -0.334411 13.7063 0.293713L15.7063 2.29371C16.0969 2.68434 16.0969 3.31559 15.7063 3.70621ZM15.0875 2.91246L13.0875 0.912463C13.0094 0.834338 12.875 0.890588 12.875 0.999963V4.99996C12.875 5.11246 13.0094 5.16871 13.0875 5.08746L15.0875 3.08746C15.1375 3.04059 15.1375 2.95934 15.0875 2.91246Z"
        fill={color}
      />
    </svg>
  );
};
